import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard } from './authGuard'
import { claims } from '@/constants'


Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/Dashboard'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.dashboard
    }
  },
  {
    path: '/hours',
    name: 'hours',
    component: () => import('@/views/Hours'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.hours
    }
  },
  {
    path: '/account/settings',
    name: 'accountSettings',
    component: () => import('@/views/Account/Settings'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.profile
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/Account/Profile'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.profile
    }
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('@/views/Contacts'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.contact
    }
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/views/Projects'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.project
    }
  },
  {
    path: '/members',
    name: 'members',
    component: () => import('@/views/Members'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.member
    }
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('@/views/Events'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.event
    }
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('@/views/Documents'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      childrenClaims: [claims.documentDocument, claims.documentContract, claims.documentSchedule]
    },
    children: [
      {
        path: 'documents',
        name: 'documentDocument',
        component: () => import('@/views/Documents/Documents'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.documentDocument
        }
      },
      {
        path: 'notes',
        name: 'documentNotes',
        component: () => import('@/views/Documents/Notes'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.documentDocument // todo
        }
      },
      {
        path: 'contracts',
        name: 'documentContract',
        component: () => import('@/views/Documents/Contracts'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.documentContract
        }
      },
      {
        path: 'schedules',
        name: 'documentSchedule',
        component: () => import('@/views/Documents/Schedules'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.documentSchedule
        }
      }
    ]
  },
  {
    path: '/budget',
    name: 'budget',
    component: () => import('@/views/Budget'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.budget
    }
  },
  {
    path: '/marketing',
    component: () => import('@/views/Marketing'),
    beforeEnter: authGuard,
    name: 'marketing',
    meta: {
      layout: 'auth-layout',
      childrenClaims: [claims.marketingPost, claims.marketingSocialAccounts]
    },
    children: [
      {
        path: 'posts',
        name: 'marketingPost',
        component: () => import('@/views/Marketing/Posts'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.marketingPost
        }
      },
      {
        path: 'social-accounts',
        name: 'marketingSocialAccounts',
        component: () => import('@/views/Marketing/SocialAccounts'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.marketingSocialAccounts
        }
      }
    ]
  },
  {
    path: '/settings',
    component: () => import('@/views/Settings'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout'
    },
    redirect: { name: 'settingsUsers' },
    children: [
      {
        path: 'users',
        name: 'settingsUsers',
        component: () => import('@/views/Settings/Users'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        },
        children: [
          {
            path: 'access',
            name: 'settingsUsersAccess',
            component: () => import('@/views/Settings/Users/Access'),
            beforeEnter: authGuard,
            meta: {
              layout: 'auth-layout'
            },
            redirect: { name: 'settingsUsersAccessSchemes' },
            children: [
              {
                path: 'schemes',
                name: 'settingsUsersAccessSchemes',
                component: () => import('@/views/Settings/Users/Access/Schemes'),
                beforeEnter: authGuard,
                meta: {
                  layout: 'auth-layout',
                  claim: claims.settings
                }
              },
              {
                path: 'projects',
                name: 'settingsUsersAccessProjects',
                component: () => import('@/views/Settings/Users/Access/Projects'),
                beforeEnter: authGuard,
                meta: {
                  layout: 'auth-layout',
                  claim: claims.settings
                }
              }
            ]
          }
        ]
      },
      {
        path: 'billing',
        name: 'settingsBilling',
        component: () => import('@/views/Settings/Billing'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'seasons',
        name: 'settingsSeasons',
        component: () => import('@/views/Settings/Seasons'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'contract-templates',
        name: 'settingsContractTemplates',
        component: () => import('@/views/Settings/ContractTemplates'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'schedule-templates',
        name: 'settingsScheduleTemplates',
        component: () => import('@/views/Settings/ScheduleTemplates'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'budget-categories',
        name: 'settingsBudgetCategories',
        component: () => import('@/views/Settings/BudgetCategories'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'event-categories',
        name: 'settingsEventCategories',
        component: () => import('@/views/Settings/EventCategories'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      },
      {
        path: 'tenant',
        name: 'settingsTenant',
        component: () => import('@/views/Settings/Tenant'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.settings
        }
      }
    ]
  },
  {
    path: '/todo',
    name: 'todo',
    component: () => import('@/views/Todo'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout',
      claim: claims.todo
    }
  },
  {
    path: '/communication/',
    name: 'communication',
    component: () => import('@/views/Communication'),
    beforeEnter: authGuard,
    redirect: { name: 'communicationEmails' },
    meta: {
      layout: 'auth-layout'
    },
    children: [
      {
        path: 'emails',
        name: 'communicationEmails',
        component: () => import('@/views/Communication/Emails'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.communication
        }
      },
      {
        path: 'sms',
        name: 'communicationSms',
        component: () => import('@/views/Communication/Sms'),
        beforeEnter: authGuard,
        meta: {
          layout: 'auth-layout',
          claim: claims.communication
        }
      }
    ]
  },
  {
    path: '/eventlog',
    name: 'eventlog',
    component: () => import('@/views/Eventlog'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/views/Unauthorized'),
    meta: {
      layout: 'error-layout'
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/Error'),
    meta: {
      layout: 'error-layout'
    }
  },
  {
    path: '/access-denied',
    name: 'accessDenied',
    component: () => import('@/views/AccessDenied'),
    beforeEnter: authGuard,
    meta: {
      layout: 'auth-layout'
    }
  },
  {
    path: '/not-found',
    name: 'notFound',
    component: () => import('@/views/NotFound'),
    meta: {
      layout: 'error-layout'
    }
  },
  {
    path: '*',
    redirect: { name: 'notFound' }
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
